"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TEXT_CATEGORY_KEY = 'base';
exports.TEXT_COMPONENT_KEY = 'text';